import React, { useId, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

import { AccountRole, accountRoleLabel } from "./accountConfig";
export type { AccountRole, AccountPageProps } from "./accountConfig";

export default function AccountSidebar({ activeItem, avatar, name, role = "Admin" }: {
  activeItem: string; avatar: string; name?: string; role?: AccountRole;
}) {
  const [open, setOpen] = useState(false);
  const id = useId();
  const suffix = role === "Admin" ? "admin" : role === "Colaborador" ? "colaborador" : "usuario-comum";
  const link = (key: string, to: string, label: string) => <Link key={key} to={to}
    className={`nav-link ${activeItem === key ? "active" : ""}`}
    aria-current={activeItem === key ? "page" : undefined} onClick={() => setOpen(false)}>{label}</Link>;
  return <>
    <button type="button" className="sidebar-toggle admin-menu-toggle" aria-controls={id} aria-expanded={open}
      aria-label={open ? "Fechar menu da conta" : "Abrir menu da conta"} onClick={() => setOpen(!open)}>
      {open ? <X size={22} /> : <Menu size={22} />}<span>Menu da conta</span>
    </button>
    <div id={id} className={`sidebar admin-account-sidebar bg-white p-4 rounded ${open ? "sidebar-open" : ""}`}>
      <div className="text-center mb-4">
        <img src={avatar} alt="" className="rounded-circle mb-3" />
        <h5 className="mb-0">{name || accountRoleLabel(role)}</h5>
        <span className="account-role-label">{accountRoleLabel(role)}</span>
      </div>
      <nav className="nav flex-column" aria-label="Menu da conta">
        <div className="account-menu-group" role="group" aria-label="Acervo e contribuições">
          {role === "Admin" && link("dashboard", "/dashboard-admin", "Visão geral")}
          {link("buscar", "/searchscreen", "Acervo de imagens")}
          {link("colaborar", `/colaborar-${suffix}`, "Colaborar com imagens")}
          {link(role === "Comum" ? "minhas-colaboracoes" : "solicitacoes", role === "Admin" ? "/solicitacoes-admin" : `/minhas-colaboracoes-${suffix}`, "Minhas solicitações")}
        </div>
        {role === "Admin" && <div className="account-menu-group" role="group" aria-label="Administração">
          {link("solicitacoes-coloboracao", "/solicitacao-colaboracao-admin", "Solicitações de colaboração")}
          {link("contas-usuario", "/contas-usuarios-admin", "Contas de usuários")}
        </div>}
        <div className="account-menu-group" role="group" aria-label="Minha conta">
          {link("perfil", `/profile-${suffix}`, "Meu perfil")}
          {link("outras-informacoes", `/outras-informacoes-${suffix}`, "Outras informações")}
          {link("alterar-senha", `/mudar-senha-${suffix}`, "Alterar senha")}
        </div>
      </nav>
    </div>
  </>;
}
